// escapeHtml.js - Échappement HTML, source unique partagée par toute l'application.
//
// Remplace les implémentations dupliquées qui existaient dans mapUtils,
// eventEditUtils, fusionManager et gedcomFileHandler. NE PAS redéfinir
// localement : importer depuis ce module.

/**
 * Échappe les caractères HTML sensibles (& < > " ') pour une interpolation
 * sûre dans du markup — aussi bien en contexte texte (innerHTML, SVG <text>)
 * qu'en contexte attribut (value="…", title="…"), où les guillemets doivent
 * également être encodés.
 *
 * @param {*} value - Valeur à échapper (convertie en chaîne ; null/undefined → '')
 * @returns {string} Chaîne sûre pour injection HTML
 */
export function escapeHtml(value) {
    if (value === null || value === undefined) return '';
    return String(value).replace(/[&<>"']/g, (ch) => ({
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
    })[ch]);
}
